export const colors = {
  primary: '#7760d7',
  primaryTransparent: '#7760d733',
  primaryBorder: '#714dc639',
  primaryLight: '#EFEBFF',
  primarySurface: '#eae7fa',
  error: '#ff4665',
  success: '#2ed22b',
  text: 'rgba(69, 69, 69, 0.88)',
  textSecondary: '#656560',
  textTertiary: '#757570',
  border: '#d9d9d9',
  borderSecondary: '#e9e9ef',
  fill: '#0000000f',
  fillSecondary: '#efefef',
  bgContainer: '#ffffff',
  bgLayout: '#f1f1f1',
  bgElevated: '#ffffff',
  bgCardHeader: '#f7f7f7',
} as const;

export const darkColors = {
  primary: '#a78bfa',
  primaryTransparent: '#a78bfa33',
  primaryBorder: '#a78bfa66',
  primaryLight: '#2d2a4a',
  primarySurface: '#3a2f5c',
  error: '#ff7085',
  success: '#73d97b',
  text: 'rgba(255, 255, 255, 0.88)',
  textSecondary: 'rgba(255, 255, 255, 0.65)',
  textTertiary: 'rgba(255, 255, 255, 0.45)',
  border: '#424242',
  borderSecondary: '#2a2a2a',
  fill: 'rgba(255, 255, 255, 0.08)',
  fillSecondary: 'rgba(255, 255, 255, 0.04)',
  bgContainer: '#1f1f1f',
  bgLayout: '#141414',
  bgElevated: '#262626',
  bgCardHeader: '#2a2a2a',
} as const satisfies Record<keyof typeof colors, string>;

export type ColorKey = keyof typeof colors;
